import { render } from "./ClipTimeline.vue?vue&type=template&id=2130ad1c&scoped=true"
import script from "./ClipTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./ClipTimeline.vue?vue&type=script&setup=true&lang=js"

import "./ClipTimeline.vue?vue&type=style&index=0&id=2130ad1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2130ad1c"],['__file',"src/components/LiveClipping/ClipTimeline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2130ad1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2130ad1c', __exports__)) {
    api.reload('2130ad1c', __exports__)
  }
  
  module.hot.accept("./ClipTimeline.vue?vue&type=template&id=2130ad1c&scoped=true", () => {
    api.rerender('2130ad1c', render)
  })

}


export default __exports__